export default __webpack_public_path__ + "static/media/flag-icon.dcd3c17e.svg";